const imageArchiveSwedish = {
  header: {
    title: "Bildarkiv",
    description: "Ladda upp och hantera bilder för dina LinkedIn-inlägg."
  },
  upload: {
    dragDrop: "Dra och släpp bilder här",
    clickUpload: "eller klicka för att välja bilder",
    uploading: "Laddar upp...",
    uploadButton: "Ladda upp bilder",
    progress: "Uppladdningsförlopp"
  },
  gallery: {
    title: "Mina bilder",
    empty: "Inga bilder ännu",
    uploadFirst: "Ladda upp dina första bilder ovan",
    imageActions: {
      copy: "Kopiera URL",
      delete: "Ta bort bild"
    },
    deleteConfirm: "Är du säker på att du vill ta bort bilden \"{name}\"?"
  },
  notification: {
    uploadSuccess: "{count} {count, plural, =1 {bild} other {bilder}} uppladdade till ditt bildarkiv.",
    uploadTelegramSuccess: "Bild uppladdad till Telegram och redo att användas i dina inlägg",
    uploadTelegramFail: "Bilden är sparad i ditt arkiv, men kunde inte skickas till Telegram.",
    deleteSuccess: "Bilden har tagits bort.",
    deleteFail: "Ett fel inträffade när bilden skulle tas bort.",
    copySuccess: "Bild-URL kopierad till urklipp.",
    copyFail: "Kunde inte kopiera URL.",
    generalError: "Ett fel inträffade. Försök igen senare."
  },
  customerBanner: "Du hanterar bildarkiv för {customerName}",
  messages: {
    onlyImageFiles: "Endast bildfiler är tillåtna.",
    noValidUserId: "Kunde inte hitta giltigt användar-ID."
  }
};

export default imageArchiveSwedish; 